var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-messages'),_c('router-view',{attrs:{"name":"page"}}),_c('v-overlay',{attrs:{"value":_vm.appIsFetching}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"70"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }